import {
    AD_STATUS_SOLD,
    AD_TYPE_FORSALE_EN,
    commonUtils,
    COUNTRY_FINLAND_ID,
    REGION_OUTSIDE_FINLAND_ID,
} from '../../../common-assets/js/components/common_utils';
import {
    ACC_PLUGIN_CHARGE_ID,
    ACC_TOW_BAR_ID,
    CONSUMPTION_COMBINED_ID,
    DRIVE_TYPE_FOUR_WHEEL_ID,
    FUEL_TYPE_ELECTRIC_ID,
    FUEL_TYPE_HYBRID_DIESEL_ELECTRIC_ID,
    FUEL_TYPE_HYBRID_ID,
    FUEL_TYPE_HYBRID_PETROL_ELECTRIC_ID,
    POWER_UNIT_KW,
} from './components/car_option_interface';
import { advanceSearchCommon } from '../../../common-assets/js/components/advance_search_common';
import { searchPriceSlider } from '../../../common-assets/js/components/search/price_search_slider';
import { searchYearSlider } from '../../../common-assets/js/components/search/year_search_slider';
import { searchMileageSlider } from './components/mileage_search_slider';
import { advanceSearchFieldHeader } from './advance_search_field_header';
import { sliderOptionFormat } from '../../../common-assets/js/components/search/search_slider_format';
import { SEARCH_STORAGE_KEY, searchFormStorage } from '../../../common-assets/js/components/search/search_form_storage';
import { syncSimpleSearchForm } from './sync_simple_search_form';

export const advanceSearch = {
    savedSearchCode: 'S',
    // Electric = 4, Hybrid = 5, Hybrid-Petrol = 8, Hybrid-Diesel = 9
    electricFuelTypes: [
        FUEL_TYPE_ELECTRIC_ID,
        FUEL_TYPE_HYBRID_ID,
        FUEL_TYPE_HYBRID_PETROL_ELECTRIC_ID,
        FUEL_TYPE_HYBRID_DIESEL_ELECTRIC_ID,
    ],
    // "Any" checkbox and related checkboxes
    anyCheckboxMappings: [
        { checkbox: 'anyVehicleType', field: 'vehicleType[]' },
        { checkbox: 'anyFuelType', field: 'fuelType[]' },
        { checkbox: 'anyCarType', field: 'carType[]' },
        { checkbox: 'anyVanType', field: 'vanType[]' },
        { checkbox: 'anyDriveType', field: 'driveType[]' },
        { checkbox: 'anyColorType', field: 'colorType[]' },
    ],
    minimumTowWeight: 1,
    maximumTowWeight: 3500,
    minimumChargingPower: 1,
    maximumChargingPower: 1000,
    maxDealerShipSelection: 5,
    accessory_plug_in_charge_id: `advance_search_accessories_${ACC_PLUGIN_CHARGE_ID}`,
    accessory_tow_bar_id: `advance_search_accessories_${ACC_TOW_BAR_ID}`,
    drive_type_field_name: 'driveType[]',
    isDesktopView: commonUtils.isSearchModalDesktopView(),
    preventModalClose: false,
    clickStartedInModal: false,
    init() {
        let $body = $('body');
        let $make = $('#advance_search #make');

        // On window resize check the width and change isDesktopView as per large/small view
        // to make it working as per view
        $(globalThis).on('resize', function () {
            advanceSearch.setDesktopMobileView(true);
        });

        // Hide accessories section when ad type is sold
        $body.on('change', '#advSearchContainer .statusType', function () {
            advanceSearch.disableOrHideAccessoriesSection(true);
        });

        // Save search agent
        $body.on('click', '#advSearchContainer .saveSearchAgentButton', function () {
            let source = $(this).data('source');
            advanceSearch.saveSearchAgent(source);
        });

        // FinlandOnly changes
        $body.on('change', '#advance_search #finlandOnly', function () {
            advanceSearchCommon.changeFinlandOnly();
            advanceSearchFieldHeader.showSelectedValueInFieldHeader($('[name="regionTown"]'));
        });

        // When undriven checked disable & reset mileage fields
        $body.on('click', '#advance_search #undriven', function () {
            if ($(this).is(':checked')) {
                advanceSearch.disableMileageForUndriven();
            } else {
                $('#advance_search .disableForUndriven').removeClass('disabled-element');
            }
        });

        // Set select2 search box focus for only desktop
        $(document).on('select2:open', () => {
            if (!this.isDesktopView) {
                $('.select2-search__field').prop('focus', false);
            }
        });

        // Display placeholder in search box input of select2
        $('#advance_search #regionTown').on('select2:open', function () {
            $(this)
                .data('select2')
                .$dropdown.find('.select2-search__field')
                .attr('placeholder', Translations.advanced_search.region_placeholder)
                .prop('focus', false);
        });

        // Remove region/town option
        $body.on('click', '#advance_search .removeRegionTownOpt', function (event) {
            // Desktop : Dont remove location selected chip/criteria when click other than X area/icon
            if ($(event.target).hasClass('removeRegionTownOpt') && advanceSearch.isDesktopView) {
                return;
            }

            advanceSearchCommon.removeRegionTownOption($(this));
            advanceSearchFieldHeader.showSelectedValueInFieldHeader($('[name="regionTown"]'));
        });

        // Reset form elements for specific section
        $body.on('click', '#advance_search .resetAdvField', function () {
            advanceSearch.resetFormElement($(this));
        });

        // Reset form elements for all sections
        $body.on('click', '#advance_search .resetWholeAdvSearchFields', function () {
            $('.advanceSearchStaticToMainOption')
                .prop('checked', false)
                .closest('div')
                .removeClass('opacity_class pointer-events-none');

            $('#advance_search .resetAdvField').each(async function () {
                // After reset all section elements call for search counter to prevent multiple search counter call to API
                // so passed here false to don't call for search counter
                await advanceSearch.resetFormElement($(this), false);
            });

            // Call the counter after resting fields from above
            searchFormStorage.resetAll().then(() => {
                globalThis.dispatchEvent(
                    new CustomEvent('advanceFieldChange', {
                        detail: {
                            action: 'resetAll',
                            fieldName: '',
                            fieldValue: '',
                        },
                    })
                );
            });
        });

        // Show field reset icon for specific section in which changes made & update search counter
        $body.on(
            'change',
            '#advance_search .checkBoxCounter, #advance_search .radioCounter, #advance_search .selectCounter',
            function () {
                advanceSearch.resetAnyElement($(this));
                advanceSearchCommon.updateCounterOnChangeElement($(this));
            }
        );

        // Show selected value in header, not condition added with specific fields are combination with other in same section
        // to display main field values only in header
        $('#advance_search .checkBoxCounter, #advance_search .radioCounter, #advance_search .selectCounter')
            .not(
                'input[name^="any"], input[name="consumptionPlace"], input[name="electricConsumptionPlace"], input[name="isPriced"], input[name="vatDeduct"], input[name="taxFree"], input[name="towWeightWithBrakes"], input[name="excludeMakeModel"]'
            )
            .change(function () {
                advanceSearchFieldHeader.showSelectedValueInFieldHeader($(this), true);
            });

        // Attach change handlers to popup form fields
        $body.on('change', '#advance_search input,#advance_search select', function () {
            // Update counter for free format model/search text/price/textbox
            if ($(this).is('input[type="text"]')) {
                // Prevent adding script tags in free format inputs
                $(this).val(
                    $(this)
                        .val()
                        .replaceAll(/<[^>]*>?/gm, '')
                );

                let elementName = this.name;
                switch (elementName) {
                    case 'yearFrom':
                    case 'yearTo':
                        advanceSearch.validateYear($(this));
                        break;
                    case 'priceFrom':
                    case 'priceTo':
                        sliderOptionFormat.validateRange($(this), searchPriceSlider);
                        break;
                    case 'kilometersFrom':
                    case 'kilometersTo':
                        sliderOptionFormat.validateRange($(this), searchMileageSlider);
                        break;
                    case 'chargingPowerFrom':
                    case 'chargingPowerTo':
                        advanceSearch.validateChargingPower($(this).attr('id'));
                        break;
                    case 'co2EmissionFrom':
                    case 'co2EmissionTo':
                        advanceSearch.validateCo2Emission($(this).attr('id'));
                        break;
                    case 'towWeightFrom':
                    case 'towWeightTo':
                        advanceSearch.validateTowWeight($(this).attr('id'));
                        break;
                    default:
                        break;
                }

                advanceSearch.resetAnyElement($(this));
                advanceSearchFieldHeader.showSelectedValueInFieldHeader($(this), true);
                advanceSearchCommon.updateCounterOnChangeElement($(this));
                advanceSearch.updateStorageAndSync($(this));
            } else {
                advanceSearch.updateStorageAndSync($(this));
            }
        });

        globalThis.addEventListener('advanceMakeModelChange', function () {
            advanceSearch.updateStorageAndSync($('#advance_search #makeModelSelected'));
        });

        globalThis.addEventListener('advanceParentDealerChange', function () {
            advanceSearch.updateStorageAndSync($('#advance_search #parentDealerSelected'));
        });

        globalThis.addEventListener('advanceLocationChange', function () {
            advanceSearch.updateStorageAndSync($('#advance_search #regionTownSelected'));
        });

        globalThis.addEventListener('advanceFieldChange', function (e) {
            let { action } = e.detail;
            let fieldName = e.detail.fieldName.replace('[]', '');
            advanceSearch.adCounter();
            syncSimpleSearchForm.loadSimpleSearchForm(action, fieldName);
        });

        // Remove make/model option
        $body.on('click', '#advance_search .removeMakeModelOpt', function (event) {
            // Desktop : Dont remove make/model selected chip/criteria when click other than X area/icon
            if ($(event.target).hasClass('removeMakeModelOpt') && advanceSearch.isDesktopView) {
                return;
            }

            // Mobile view: Chip removal is allowed when click X icon / other than X icon area
            // 'removeFromDesktop' is passed to prevent multiple search counter call when remove from mobile
            advanceSearch.removeMakeModelOption($(this));
            advanceSearch.showHideAddMakeModelSelectionLink();
            // To update the make/model field header value
            advanceSearchFieldHeader.showSelectedValueInFieldHeader($('[name="make"]'));
        });

        // Set first checkbox checked always if user try to unset both
        $body.on('click', '#advance_search input:checkbox[name="postedBy[]"]', function (event) {
            advanceSearchCommon.checkPostedBy(event);
        });

        // load dependent options
        $body.on('click', '#advance_search input[name="vehicleType[]"]', function () {
            advanceSearch.checkVehicleTypeDependentOptions();
        });

        // check/uncheck accessories based on master/child accessory check/uncheck
        $body.on('click', '#advance_search input[name="accessories[]"]', function () {
            advanceSearch.selectDeselectAccessories($(this));
        });

        // Allow only numeric input
        $body.on('input', '#advance_search .allowIntegerOnly', function () {
            commonUtils.allowInteger($(this));
        });

        // If "Any" checkbox selected deselect all related types, elseif no options selected change "Any" to selected
        advanceSearch.anyCheckboxMappings.forEach((option) => {
            $body
                .on('change', `#advance_search #${option.checkbox}`, function () {
                    advanceSearch.checkOptionsWithAnyCheckbox(option.checkbox, option.field);
                    // Hide/show electric fuel type dependant fields
                    if (option.field === 'fuelType[]') {
                        advanceSearch.showHideDependantElectricField(false, true);
                    }
                })
                .on('click', `#advance_search input[name="${option.field}"]`, function () {
                    advanceSearch.setUnsetAnyCheckbox(option.checkbox, option.field);
                    // Hide/show electric fuel type dependant fields
                    if (option.field === 'fuelType[]') {
                        advanceSearch.showHideDependantElectricField(false, true);
                    }
                });
        });

        // Advance search form submit
        $body.on('click', '#advSearchContainer #showSearchResult', async function () {
            // 100ms delay to ensure text field values are captured
            // Text fields only update storage on change/blur event. If user types and directly
            // clicks submit button without clicking elsewhere, the change event doesn't fire.
            // This delay allows time for any pending change events to complete before form submission.
            await new Promise((resolve) => {
                setTimeout(resolve, 100);
            }).then(() => {
                /* delay complete */
            });

            if (advanceSearch.validateInspectionAndRegistration()) {
                advanceSearch.saveSearchAgentData();
            }

            return false;
        });

        // Add another make/model option
        $body.on('click', '#advance_search #addAnotherMakeModel', function () {
            $make.val('');
            advanceSearch.advanceSearchMakeSelect2Event();
            $('#advance_search #model').find('option').not(':first').remove();
            $make.select2('open');
        });

        // Add another location
        $body.on('click', '#advance_search #addAnotherLocation', function () {
            let $regionTown = $('#advance_search #regionTown');
            $regionTown.val('');
            advanceSearchCommon.setRegionTownSelect2NoResultText();
            $regionTown.select2('open');
        });

        // Show/Hide van types options
        $body.on('click', '#advance_search .showHideVanTypes', function () {
            let $vanType = $('#advance_search #vanSubType, #advance_search #vanSubTypeAny');
            $vanType.toggle();
            let vanTypeText = $vanType.is(':visible')
                ? Translations.advanced_search.hide_van_subtype
                : Translations.advanced_search.show_van_subtype;
            $('#advance_search .showHideVanTypes').text(vanTypeText);
        });

        // Show selected location value in field header
        $('#regionTown').on('select2:select', function () {
            advanceSearchFieldHeader.showSelectedValueInFieldHeader($(this));
        });

        // Close advance search modal
        $body.on('click', '#advSearchContainer .closeAdvanceSearchModal', function () {
            $('#advanceSearchModal').hide();
            accessibility.restoreFocusOutsideModal();
            // Restore focus to the element that triggered the modal
            if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
                lastFocusedElement.focus();
            }
            $('body').removeClass('over-hidden');
        });

        // Handle static accessory/drivetype options - start
        $body.on('click', '#advSearchContainer .advanceSearchStaticToMainOption', function () {
            advanceSearch.advanceSearchStaticToMainOption($(this));
        });
        $body.on('click', '#advSearchContainer .advanceSearchMainToStaticOption', function () {
            advanceSearch.advanceSearchMainToStaticOption($(this));
        });

        // In case of simple search when make/model selected
        if ($make.val() && $make.data('simple_search_make_id')) {
            $make.trigger('change', [$make.data('simple_search_model_id') ? 'Y' : '']);
        }

        // Go to the section clicked from the section name at top
        $body.on('click', '#advSearchContainer .goToSection', function () {
            advanceSearchCommon.goToSectionFromTopLinkClicked($(this));
        });

        // Enable button to add selected salesforce parent id
        $('#advSearchContainer #parentDealerList').on('change', function () {
            advanceSearch.showSelectedParentDealerListOption();
            let $sectionFieldId = $(this)
                .closest(advanceSearch.isDesktopView ? '.desktopFieldSection' : '.mobileFieldSection')
                .attr('id');
            advanceSearchCommon.showHideResetIcon($sectionFieldId);

            if (!advanceSearch.isDesktopView) {
                advanceSearchFieldHeader.showSelectedValueInFieldHeader($(this), true);
            }
        });

        // Remove salesforce parent id option
        $body.on('click', '.removeSelectedParentDealerOption span', function () {
            advanceSearch.removeSelectedParentOption($(this).closest('.removeSelectedParentDealerOption'));
        });

        // Add class to main options for static options based on user preference
        $('.advanceSearchStaticToMainOption').each(function () {
            const $static = $(this);

            if ($static.hasClass('preferenceAccessoryCheckbox') || $static.hasClass('preferenceColorCheckbox')) {
                const accessoryId = $static.data('preference-accessory-id');
                const colorId = $static.data('preference-color-id');
                if (accessoryId !== undefined) {
                    $(`#advance_search_accessories_${accessoryId}`).addClass('advanceSearchMainToStaticOption');
                } else if (colorId !== undefined) {
                    $(`#advance_search input[type="checkbox"][name="color[]"][value="${colorId}"]`).addClass(
                        'advanceSearchMainToStaticOption'
                    );
                }
            }
        });

        // "to" dropdown should start with selected "from" dropdown value
        advanceSearch.repopulateRangeFields();

        // Update make dependent options and add selected make
        $('#advance_search #make').on('change', function (__event, resetMakeModelSection = '') {
            let $makeId = $(this).val() ? Number.parseInt($(this).val(), 10) : '';
            let $vehicleTypeIds = $('input[id^=vehicleType]:checked')
                .map(function () {
                    return Number.parseInt(this.value, 10);
                })
                .get()
                .join();

            // Clear model Select2 selection when make changes
            $('#advance_search #model').val(null).trigger('change.select2');
            $('#advance_search #model').find('option').not(':first').remove();
            advanceSearch.checkMakeDependentOptions($vehicleTypeIds, $makeId, resetMakeModelSection);

            // Skip pill creation if coming from simple search with model selected
            if ('Y' === resetMakeModelSection) {
                return;
            }

            // Add selected make/model options (make only - triggers on make selection without model)
            advanceSearch.showSelectedMakeModelOption();
            // Show reset icon
            let $sectionFieldId = $(this)
                .closest(advanceSearch.isDesktopView ? '.desktopFieldSection' : '.mobileFieldSection')
                .attr('id');
            advanceSearchCommon.showHideResetIcon($sectionFieldId);
            advanceSearch.showHideAddMakeModelSelectionLink();
            advanceSearchFieldHeader.showSelectedValueInFieldHeader($(this));
        });

        // Model selection event - toggle make/model pill (add if not exists, remove if exists)
        $('#advance_search #model').on('select2:select', function (e) {
            const selectedData = e.params.data;
            const $makeSelect = $('#advance_search #make');
            const makeId = $makeSelect.find('option:selected').val();
            const modelId = selectedData.id;

            // Check if this make/model combination already exists
            let alreadyExists = false;
            $('#makeModelSelected option').each(function () {
                if ($(this).data('make-id') === makeId && $(this).data('model-id') === modelId) {
                    alreadyExists = true;
                }
            });

            advanceSearch.showSelectedMakeModelOption(selectedData.id, selectedData.text, alreadyExists);

            // Reset dropdown to show placeholder instead of selected value
            $('#advance_search #model').val(null).trigger('change.select2');

            // Show reset icon
            let $sectionFieldId = $(this)
                .closest(advanceSearch.isDesktopView ? '.desktopFieldSection' : '.mobileFieldSection')
                .attr('id');
            advanceSearchCommon.showHideResetIcon($sectionFieldId);
            advanceSearch.showHideAddMakeModelSelectionLink();
            advanceSearchFieldHeader.showSelectedValueInFieldHeader($(this));
        });

        // Expand/collapse section for mobile layout
        // Here off is added to detach event first then attach it again because opened search modal -> sections was being worked only odd time
        $('#advance_search .expandCollapseSection, #advance_search .expandCollapseSectionMobile')
            .off()
            .on('click', function () {
                advanceSearchCommon.expandCollapseLayers($(this));
            });

        // Location dropdown changes
        advanceSearchCommon.changeLocationDropdown(false);

        // Select 2 event for Make
        advanceSearch.advanceSearchMakeSelect2Event();

        // Select 2 event for Model
        advanceSearch.advanceSearchModelSelect2Event();

        // select 2 event for Parent Dealer List
        advanceSearch.advanceSearchParentDealerSelect2Event();

        // Set default no search result text for select2
        advanceSearchCommon.setRegionTownSelect2NoResultText();

        // Region/Town selection event
        advanceSearchCommon.regionTownSelect2Event();
    },
    disableMileageForUndriven() {
        $('#advance_search .disableForUndriven').addClass('disabled-element');
        $('#advance_search #kilometersFrom,#advance_search #kilometersTo').val('');
        if (searchMileageSlider.sliderName.length > 0) {
            searchMileageSlider.setSlider(0, 0);
        }
    },
    repopulateRangeFields() {
        // Define all range field pairs that use changeFromToOptions
        const rangeFields = [
            // Electric Power fields
            { from: 'batteryCapacityFrom', to: 'batteryCapacityTo' },
            { from: 'electricRangeFrom', to: 'electricRangeTo' },
            { from: 'electricConsumptionFrom', to: 'electricConsumptionTo' },
            { from: 'maximumChargingPowerFrom', to: 'maximumChargingPowerTo' },
            { from: 'batteryGuaranteeMonthFrom', to: 'batteryGuaranteeMonthTo' },
            { from: 'batteryGuaranteeKmFrom', to: 'batteryGuaranteeKmTo' },

            // Technical Info fields
            { from: 'consumptionFrom', to: 'consumptionTo' },
            { from: 'engineSizeFrom', to: 'engineSizeTo' },
            { from: 'powerFrom', to: 'powerTo' },
            { from: 'torqueFrom', to: 'torqueTo' },
            { from: 'curbWeightFrom', to: 'curbWeightTo' },
            { from: 'accelerationFrom', to: 'accelerationTo' },
            { from: 'topSpeedFrom', to: 'topSpeedTo' },
            { from: 'seatsFrom', to: 'seatsTo' },
            { from: 'doorsFrom', to: 'doorsTo' },
        ];

        // Initialize each range field pair
        rangeFields.forEach(function (field) {
            const fromField = document.querySelector(`#advance_search select[name="${field.from}"]`);
            const toField = document.querySelector(`#advance_search select[name="${field.to}"]`);

            if (fromField && toField && fromField.selectedIndex > 0) {
                // Call changeFromToOptions to properly sync the dropdowns
                commonUtils.changeFromToOptions(fromField, toField, '');
            }
        });
    },
    async callFunctionsOnModalOpen(haku = '') {
        const searchKey = haku;
        searchFormStorage.storageKey = SEARCH_STORAGE_KEY + (searchKey ? `_${searchKey}` : '');

        const formData = await searchFormStorage.getFormData();
        await this.beforeInit(formData);

        // Hide accessories section when ad type is sold
        advanceSearch.disableOrHideAccessoriesSection();

        // Whenever opens search modal call this function to decide view
        advanceSearch.setDesktopMobileView();

        // Show all section opened for desktop
        advanceSearch.showAllSectionOpenByDefault();

        // Show default reset icon, Here setTimeout function used due to location field value loaded with ajax request
        // and due to that delay blueBarInit default value when page loaded and changed location value shows different when compare so
        // reset field icon not worked properly.
        setTimeout(function () {
            advanceSearchCommon.showResetIconOnLoad();
        }, 5);

        // Show selected value in field header, not condition added with specific fields are combination with other in same section
        // to display main field values only in header
        advanceSearchFieldHeader.showSelectedValueInFieldOnLoad();

        advanceSearch.showHideDependantElectricField();

        advanceSearch.advanceSearchMainToStaticOption(
            $(`#advance_search input[name="${this.drive_type_field_name}"][value="${DRIVE_TYPE_FOUR_WHEEL_ID}"]`)
        );
        advanceSearch.advanceSearchMainToStaticOption($(`#advance_search [id="${this.accessory_plug_in_charge_id}"]`));
        advanceSearch.advanceSearchMainToStaticOption($(`#advance_search [id="${this.accessory_tow_bar_id}"]`));

        // If make/model already selected show Ad Another link
        advanceSearch.showHideAddMakeModelSelectionLink();

        let $yearFrom = $('#advance_search #yearFrom');
        let $yearTo = $('#advance_search #yearTo');
        let $yearSlider = $('#advance_search #yearSlider');
        if (searchYearSlider.sliderName.length > 0 && $yearSlider.hasClass('ui-slider')) {
            searchYearSlider.setSlider($yearFrom.val(), $yearTo.val());
        } else {
            searchYearSlider.init({
                sliderName: $yearSlider,
                fromElement: $yearFrom,
                toElement: $yearTo,
            });
        }

        let $priceFrom = $('#advance_search #priceFrom');
        let $priceTo = $('#advance_search #priceTo');
        let $priceSlider = $('#advance_search #priceSlider');
        if (searchPriceSlider.sliderName.length > 0 && $priceSlider.hasClass('ui-slider')) {
            searchPriceSlider.setSlider($priceFrom.val(), $priceTo.val());
        } else {
            searchPriceSlider.init({
                sliderName: $priceSlider,
                fromElement: $priceFrom,
                toElement: $priceTo,
            });
        }

        let $kilometersFrom = $('#advance_search #kilometersFrom');
        let $kilometersTo = $('#advance_search #kilometersTo');
        let $kilometerSlider = $('#advance_search #kilometerSlider');
        if (searchMileageSlider.sliderName.length > 0 && $kilometerSlider.hasClass('ui-slider')) {
            searchMileageSlider.setSlider($kilometersFrom.val(), $kilometersTo.val());
        } else {
            searchMileageSlider.init({
                sliderName: $kilometerSlider,
                fromElement: $kilometersFrom,
                toElement: $kilometersTo,
            });
        }

        // Get search counter
        setTimeout(() => {
            advanceSearch.adCounter();
        }, 100); // Timeout set high due to bodytype ajax content taking time
    },
    beforeInit(formData) {
        const formElement = $('#advance_search');
        // Set selected data in advance search form
        return new Promise((resolve, reject) => {
            try {
                // Reset elements which are set when change from simple search
                // i.e. select vehicle type -> open search model -> close search model -> update vehicle type from left search -> open search model
                // i.e. Left search form select -> Open search model -> Reset from left search from -> It should reset also in search model
                // It should not show previously selected option
                formElement.find('[name="vehicleType[]"]').prop('checked', false);
                formElement.find('[name="carType[]"]').prop('checked', false);
                formElement.find('[name="vanType[]"]').prop('checked', false);
                formElement.find('[name="fuelType"][value=""]').prop('checked', true);
                formElement.find('[name="gearType"][value=""]').prop('checked', true);
                formElement.find('[name="undriven"]').prop('checked', false);

                advanceSearch.resetElementsById('makeModelSelected');
                formElement.find('[name="accessories[]"]').prop('checked', false);
                formElement.find('[name="driveType[]"]').prop('checked', false);
                advanceSearch.resetElementsById('regionTownSelected');
                advanceSearch.resetElementsById('locationFields');

                const fieldsToReset = ['priceFrom', 'priceTo', 'yearFrom', 'yearTo', 'kilometersFrom', 'kilometersTo'];

                fieldsToReset.forEach((fieldName) => {
                    formElement.find(`[name="${fieldName}"]`).val('');
                });

                // On initialize set only those which are set in storage
                const vehicleTypeIds = formData.vehicleType || '';
                const bodyTypeIds = formData.bodyType || '';
                const makeModels = formData.makeModels || {};
                const locations = formData.locations || {};
                const salesforceParentIds = formData.salesforceParentIds || {};

                if (vehicleTypeIds && Array.isArray(vehicleTypeIds) && vehicleTypeIds.length > 0) {
                    vehicleTypeIds.forEach((vehicleTypeId) => {
                        formElement.find(`[name="vehicleType[]"][value="${vehicleTypeId}"]`).prop('checked', true);
                    });
                    formElement.find('[name="anyVehicleType"]').prop('checked', false);
                } else {
                    formElement.find('[name="anyVehicleType"]').prop('checked', true);
                }

                let anyCarType = true,
                    anyVanType = true;
                if (bodyTypeIds && Array.isArray(bodyTypeIds) && bodyTypeIds.length > 0) {
                    bodyTypeIds.forEach((bodyTypeId) => {
                        let carTypeElement = formElement.find(`[name="carType[]"][value="${bodyTypeId}"]`);
                        let vanTypeElement = formElement.find(`[name="vanType[]"][value="${bodyTypeId}"]`);
                        if (carTypeElement.length > 0) {
                            carTypeElement.prop('checked', true);
                            anyCarType = false;
                        } else if (vanTypeElement.length > 0) {
                            vanTypeElement.prop('checked', true);
                            anyVanType = false;
                        }
                    });
                }

                formElement.find('[name="anyCarType"]').prop('checked', anyCarType);
                formElement.find('[name="anyVanType"]').prop('checked', anyVanType);

                if (!formData.fuelType) {
                    formElement.find('[name="anyFuelType"]').prop('checked', true);
                }
                if (!formData.colorType) {
                    formElement.find('[name="anyColorType"]').prop('checked', true);
                }
                if (!formData.driveType) {
                    formElement.find('[name="anyDriveType"]').prop('checked', true);
                }

                if (Object.keys(makeModels).length > 0) {
                    const $makeModelSelected = formElement.find('#makeModelSelected');
                    const $makeModelSelectedDiv = formElement.find('#makeModelSelectedDiv');

                    Object.keys(makeModels).forEach((key) => {
                        const [make = '', model = ''] = key.split(',');
                        const displayText = makeModels[key];
                        $makeModelSelected.append(
                            `<option data-make-id="${make}" data-model-id="${model}" value="${key}" selected="selected">${displayText}</option>`
                        );
                        $makeModelSelectedDiv.append(
                            `<div data-id="${key}" class="multiple-seleced-text removeMakeModelOpt">${displayText}<span class="form-control__reset-btn">Remove</span></div>`
                        );
                    });

                    $('#advance_search #noMakeModelSelected').hide();
                }

                // Handle region and town selection
                if (Object.keys(locations).length > 0) {
                    const $regionSelected = $('#regionTownSelected');
                    const $regionTownIdDiv = formElement.find('#regionTownSelectedDiv');

                    // Handle All foreign countries
                    if (
                        Object.keys(locations).length === 1 &&
                        Object.keys(locations)[0] === String(REGION_OUTSIDE_FINLAND_ID)
                    ) {
                        const displayText = Translations.advanced_search.outside_finland;
                        $regionSelected.append(
                            `<option data-country="" data-region="${REGION_OUTSIDE_FINLAND_ID}" data-town="" value="${REGION_OUTSIDE_FINLAND_ID}" selected="selected">${displayText}</option>`
                        );
                        $regionTownIdDiv.append(
                            `<div data-id="${REGION_OUTSIDE_FINLAND_ID}" class="multiple-seleced-text removeRegionTownOpt">${displayText}<span class="form-control__reset-btn ">Remove</span></div>`
                        );
                    } else {
                        let isCountrySelected = false;
                        Object.keys(locations).forEach((key) => {
                            let country = '',
                                region = '',
                                town = '',
                                displayText = '';
                            // if key has prefix "c" means either selected all foreign countries or specific county
                            if (key.startsWith('c')) {
                                country = key;
                                isCountrySelected = true;
                            } else {
                                [region = '', town = ''] = key.split(',');
                            }

                            displayText = locations[key];

                            $regionSelected.append(
                                `<option data-country="${country.replace('c', '')}" data-region="${region}" data-town="${town}" value="${key}" selected="selected">${displayText}</option>`
                            );
                            $regionTownIdDiv.append(
                                `<div data-id="${key}" class="multiple-seleced-text removeRegionTownOpt">${displayText}<span class="form-control__reset-btn ">Remove</span></div>`
                            );
                        });

                        // If no country is selected, prepare dropdown for region and towns
                        if (
                            !isCountrySelected ||
                            (Object.keys(locations).length === 1 &&
                                Object.keys(locations)[0] === `c${COUNTRY_FINLAND_ID}`)
                        ) {
                            $('#advance_search #finlandOnly').prop('checked', true);
                            advanceSearchCommon.changeFinlandOnly();
                        }
                    }

                    advanceSearchCommon.showHideAddLocationSelectionLink();
                }

                // Handle engine make selection
                if (Object.keys(salesforceParentIds).length > 0) {
                    for (const salesforceParentId of Object.keys(salesforceParentIds)) {
                        const displayText = salesforceParentIds[salesforceParentId];
                        $('#parentDealerSelected').append(
                            `<option data-dealer-parent-id="${salesforceParentId}" value="${salesforceParentId}" selected="selected">${displayText}</option>`
                        );
                        $('#parentDealerSelectedDiv').append(
                            `<div data-id="${salesforceParentId}" class="multiple-seleced-text removeSelectedParentDealerOption">${displayText}<span class="form-control__reset-btn">Remove</span></div>`
                        );
                    }

                    $('#noParentDealerSelected').hide();
                }

                for (const fieldName of Object.keys(formData)) {
                    const fieldValue = formData[fieldName] || '';
                    const fieldElement = formElement.find(`[name="${fieldName}"]`);
                    // All these are dependent entities handled above separately so ignore from here
                    if (
                        [
                            'vehicleType',
                            'bodyType',
                            'carType',
                            'vanType',
                            'make',
                            'model',
                            'makeModels',
                            'locations',
                            'country',
                            'region',
                            'town',
                            'salesforceParentIds',
                        ].includes(fieldName)
                    ) {
                        continue;
                    } else if (fieldName === 'postedBy') {
                        // Note: By default both seller and dealer is selected when prepare ad form from Symfony
                        // So here need to uncheck if any one is selected
                        if (fieldValue === 'dealer') {
                            formElement.find(`[name="${fieldName}[]"][value="dealer"]`).prop('checked', true);
                            formElement.find(`[name="${fieldName}[]"][value="seller"]`).prop('checked', false);
                        } else if (fieldValue === 'seller') {
                            formElement.find(`[name="${fieldName}[]"][value="dealer"]`).prop('checked', false);
                            formElement.find(`[name="${fieldName}[]"][value="seller"]`).prop('checked', true);
                        }
                        continue;
                    }

                    // Handle grouped elements (e.g., checkboxes "color,color type, accessories") If value is an array
                    if (Array.isArray(fieldValue)) {
                        fieldValue.forEach((value) => {
                            let element = formElement.find(`[name="${fieldName}[]"][value="${value}"]`);
                            element.prop('checked', true);

                            // Set parent accessories based on child accessories selected if parent-child relation exists
                            if (fieldName === 'accessories' && element.is('[data-parent-id]')) {
                                formElement
                                    .find(`[name="${fieldName}[]"][value="${element.data('parent-id')}"]`)
                                    .prop('checked', true);
                            }
                        });
                    } else if (fieldElement.length > 1) {
                        // Handle grouped elements (e.g., radio buttons "consumptionPlace, steeringWheelType)
                        formElement.find(`[name="${fieldName}"][value="${fieldValue}"]`).prop('checked', true);
                    } else if (fieldElement.is(':checkbox')) {
                        // Handle single elements (e.g., radio or checkbox)
                        fieldElement.prop('checked', true);

                        // Special case for undriven checkbox to disable mileage fields
                        if (fieldName === 'undriven') {
                            advanceSearch.disableMileageForUndriven();
                        }
                    } else {
                        // Handle single elements (e.g., text input, select)
                        fieldElement.val(fieldValue);
                    }

                    // Update "to" fields range value if "from" field is selected
                    if (
                        [
                            'consumptionFrom',
                            'engineSizeFrom',
                            'powerFrom',
                            'torqueFrom',
                            'curbWeightFrom',
                            'accelerationFrom',
                            'topSpeedFrom',
                            'seatsFrom',
                            'doorsFrom',
                            'batteryCapacityFrom',
                            'electricRangeFrom',
                            'electricConsumptionFrom',
                            'maximumChargingPowerFrom',
                            'batteryGuaranteeMonthFrom',
                            'batteryGuaranteeKmFrom',
                        ].includes(fieldName)
                    ) {
                        // Trigger change event for range fields
                        let event = new Event('change');
                        fieldElement[0].dispatchEvent(event);
                    }
                }

                resolve();
            } catch (error) {
                reject(error);
            }
        });
    },
    // Update a field value in storage and sync left search form
    async updateStorageAndSync($field) {
        const popupForm = $('#advance_search');
        let isRemove = false;
        let fieldName = $field.attr('name');
        let fieldValue = $field.val();

        // Special case for slider elements
        // When change value from slider it triggers change event of "from" element, So it require to sync "to" element
        // i.e. searchYearSlider.fromElement.trigger('change'); OR searchPriceSlider.fromElement.trigger('change');
        if (['priceFrom', 'yearFrom', 'kilometersFrom'].includes(fieldName)) {
            let toField = fieldName.replace('From', 'To');
            await searchFormStorage.updateField(toField, popupForm.find(`[name="${toField}"]`).val());
        }

        // If any range field from value is changed then reset the "to" field value in storage if "to" value is less than "from" value
        if (
            [
                'consumptionFrom',
                'engineSizeFrom',
                'powerFrom',
                'torqueFrom',
                'curbWeightFrom',
                'accelerationFrom',
                'topSpeedFrom',
                'seatsFrom',
                'doorsFrom',
                'batteryCapacityFrom',
                'electricRangeFrom',
                'electricConsumptionFrom',
                'maximumChargingPowerFrom',
                'batteryGuaranteeMonthFrom',
                'batteryGuaranteeKmFrom',
            ].includes(fieldName)
        ) {
            let toField = fieldName.replace('From', 'To');
            let rangeToValue = popupForm.find(`[name="${toField}"]`).val();
            // Remove "to" field value if less than "from" field value
            if (rangeToValue === '' || Number.parseInt(rangeToValue, 10) < Number.parseInt(fieldValue, 10)) {
                await searchFormStorage.deleteField(toField);
            }
        }

        // For checkboxes (vehicleType, carType, fuelType,..)
        if ($field.is('input[type="checkbox"]')) {
            fieldName = fieldName.replace('[]', '');
            const checkboxFields = [
                'vehicleType',
                'carType',
                'vanType',
                'fuelType',
                'driveType',
                'chargingType',
                'accessories',
                'color',
                'colorType',
            ];

            if (['carType', 'vanType', 'anyCarType', 'anyVanType'].includes(fieldName)) {
                fieldValue = $('input[name="carType[]"]:checked, input[name="vanType[]"]:checked')
                    .map(function () {
                        return Number.parseInt($(this).val(), 10);
                    })
                    .get()
                    .filter(Boolean);

                if (fieldName === 'anyCarType' && $field.is(':checked')) {
                    fieldValue = $('input[name="vanType[]"]:checked')
                        .map(function () {
                            return Number.parseInt($(this).val(), 10);
                        })
                        .get()
                        .filter(Boolean);
                }
                // If "anyVanType" is checked, include only car types
                else if (fieldName === 'anyVanType' && $field.is(':checked')) {
                    fieldValue = $('input[name="carType[]"]:checked')
                        .map(function () {
                            return Number.parseInt($(this).val(), 10);
                        })
                        .get()
                        .filter(Boolean);
                }
                fieldName = 'bodyType';
            } else if (checkboxFields.includes(fieldName)) {
                fieldValue = $(`input[name="${fieldName}[]"]:checked`)
                    .map(function () {
                        return fieldName === 'accessories' && $(this).val().includes('_')
                            ? ''
                            : Number.parseInt($(this).val(), 10);
                    })
                    .get()
                    .filter(Boolean);
            } else if (
                ['excludeMakeModel', 'undriven', 'isPriced', 'taxFree', 'vatDeduct', 'towWeightWithBrakes'].includes(
                    fieldName
                )
            ) {
                isRemove = !$field.is(':checked');
            } else if (fieldName === 'postedBy') {
                const dealerChecked = popupForm.find('[name="postedBy[]"][value="dealer"]').is(':checked');
                const sellerChecked = popupForm.find('[name="postedBy[]"][value="seller"]').is(':checked');

                // If both dealer and seller are checked, remove the field
                if (dealerChecked && sellerChecked) {
                    isRemove = true;
                } else if (!$field.is(':checked')) {
                    // Set value to dealer or seller based on the checked state
                    fieldValue = fieldValue === 'dealer' ? 'seller' : 'dealer';
                }
            }

            // Reset mileage field if undriven is checked
            if (fieldName === 'undriven' && $field.is(':checked')) {
                await searchFormStorage.deleteField('kilometersFrom');
                await searchFormStorage.deleteField('kilometersTo');
            }

            // Reset field if any checkbox is ticked for vehicleType, carType, etc.
            const fieldMatch = advanceSearch.anyCheckboxMappings.find((item) => item.checkbox === fieldName);
            if (fieldMatch && fieldValue === 'Y') {
                fieldName = fieldMatch.field.replace('[]', '');
                fieldValue = [];
            }
        } else if (['gearType', 'steeringWheelType', 'roadWorthy'].includes(fieldName) && fieldValue === '') {
            isRemove = true;
        } else if (fieldName === 'makeModel[]') {
            fieldName = 'makeModels';
            fieldValue = $field
                .find(':selected')
                .map(function () {
                    let obj = {};
                    obj[$(this).val()] = $(this).text().trim(); // Create key-value pair with value as key and text as value
                    return obj; // Return the key-value pair for each selected option
                })
                .get()
                .reduce(function (acc, curr) {
                    return Object.assign(acc, curr); // Merge all objects into one
                }, {});
        } else if (fieldName === 'salesforceParentId[]') {
            fieldName = 'salesforceParentIds';
            fieldValue = $field
                .find(':selected')
                .map(function () {
                    let obj = {};
                    obj[$(this).val()] = $(this).text().trim(); // Create key-value pair with value as key and text as value
                    return obj; // Return the key-value pair for each selected option
                })
                .get()
                .reduce(function (acc, curr) {
                    return Object.assign(acc, curr); // Merge all objects into one
                }, {});
        } else if (fieldName === 'locations[]') {
            fieldName = 'locations';
            fieldValue = $field
                .find(':selected')
                .map(function () {
                    let obj = {};
                    obj[$(this).val()] = $(this).text().trim(); // Create key-value pair with value as key and text as value
                    return obj; // Return the key-value pair for each selected option
                })
                .get()
                .reduce(function (acc, curr) {
                    return Object.assign(acc, curr); // Merge all objects into one
                }, {});
        } else if (fieldName === 'statusType' && fieldValue === AD_STATUS_SOLD) {
            // Remove accessories from storage for sold ads
            await searchFormStorage.deleteField('accessories');
        }

        // Update storage
        if (isRemove) {
            await searchFormStorage.deleteField(fieldName);
        } else {
            // Ignore fields which are not required to store in storage
            if (
                [
                    'finlandOnly',
                    'make',
                    'model',
                    'regionTown',
                    'parentDealerList',
                    'carType',
                    'vanType',
                    'accessoryPlugInCharge',
                    'driveTypeFourWheel',
                    'accessoryTowBar',
                ].includes(fieldName)
            ) {
                return;
            }

            await searchFormStorage.updateField(fieldName, fieldValue);
        }

        // sync a left side search form
        setTimeout(function () {
            advanceSearch.adCounter();
            syncSimpleSearchForm.loadSimpleSearchForm('fieldChange', fieldName);
        }, 100);
    },
    advanceSearchStaticToMainOption(object) {
        if (object.attr('id') === 'accessoryPlugInCharge') {
            $(`#advance_search #${this.accessory_plug_in_charge_id}`)
                .prop('checked', $('#advance_search #accessoryPlugInCharge').is(':checked'))
                .trigger('change');
        } else if (object.attr('id') === 'accessoryTowBar') {
            $(`#advance_search #${this.accessory_tow_bar_id}`)
                .prop('checked', $('#advance_search #accessoryTowBar').is(':checked'))
                .trigger('change');
        } else if (object.attr('id') === 'driveTypeFourWheel') {
            $(`input[name="${this.drive_type_field_name}"][value="${DRIVE_TYPE_FOUR_WHEEL_ID}"]`)
                .prop('checked', $('#advance_search #driveTypeFourWheel').is(':checked'))
                .trigger('change');
            advanceSearch.setUnsetAnyCheckbox('anyDriveType', 'driveType[]');
            setTimeout(function () {
                advanceSearchCommon.showHideResetIcon(
                    // For desktop section id is technicalInfoFields and for mobile it is driveTypeFields
                    advanceSearch.isDesktopView ? 'technicalInfoFields' : 'driveTypeFields'
                );
            }, 100);
        } else if (/^preferences_accessory_\d+$/.test(object.attr('id'))) {
            let selectedAccessoryId = object.data('preference-accessory-id');
            $(`#advance_search_accessories_${selectedAccessoryId}`)
                .prop('checked', $(`#preferences_accessory_${selectedAccessoryId}`).is(':checked'))
                .trigger('change');
            advanceSearch.selectDeselectAccessories($(`#advance_search_accessories_${selectedAccessoryId}`));
        } else if (/^preferences_color_\d+$/.test(object.attr('id'))) {
            let selectedColorId = object.data('preference-color-id');
            $(`.checkBoxCounter.color_${selectedColorId}`)
                .prop('checked', $(`#preferences_color_${selectedColorId}`).is(':checked'))
                .trigger('change');
        }
    },
    advanceSearchMainToStaticOption(object) {
        if (object.attr('id') === this.accessory_plug_in_charge_id) {
            $('#advance_search #accessoryPlugInCharge').prop(
                'checked',
                $(`#advance_search #${this.accessory_plug_in_charge_id}`).is(':checked')
            );
        } else if (object.attr('id') === this.accessory_tow_bar_id) {
            $('#advance_search #accessoryTowBar').prop(
                'checked',
                $(`#advance_search #${this.accessory_tow_bar_id}`).is(':checked')
            );
        } else if (object.attr('name') === this.drive_type_field_name && DRIVE_TYPE_FOUR_WHEEL_ID === object.val()) {
            $('#advance_search #driveTypeFourWheel').prop(
                'checked',
                $(`input[name="${this.drive_type_field_name}"][value="${DRIVE_TYPE_FOUR_WHEEL_ID}"]`).is(':checked')
            );
        }

        // Manage for preferences accessories and colors
        $('.preferenceAccessoryCheckbox').each(function () {
            let accessoryId = $(this).data('preference-accessory-id');
            let isCheckedInAdvanceSearch = $(`#advance_search_accessories_${accessoryId}`).is(':checked');
            $(this).prop('checked', isCheckedInAdvanceSearch);
        });

        $('.preferenceColorCheckbox').each(function () {
            let colorId = $(this).data('preference-color-id');
            let isCheckedInAdvanceSearch = $(`input[name="color[]"][value="${colorId}"]`).is(':checked');
            $(this).prop('checked', isCheckedInAdvanceSearch);
        });
    },
    showHideDependantElectricField(fromShowMoreFilters, isFuelTypeElementClick, isResetEvent = false) {
        const localFromShowMoreFilters = fromShowMoreFilters || false;
        const localIsFuelTypeElementClick = isFuelTypeElementClick || false;
        let $advanceSearchElectricPowerFields = $('.advanceSearchElectricPowerFields');
        let $fuelTypesChecked = $('input[id^=fuelType]:checked');
        let selectedElectricFuelType = $fuelTypesChecked
            .map(function () {
                let currentSelectedFuelType = Number.parseInt(this.value, 10);

                return $.inArray(currentSelectedFuelType, advanceSearch.electricFuelTypes) < 0
                    ? null
                    : currentSelectedFuelType;
            })
            .get();

        let showElectricFields = selectedElectricFuelType.length > 0 || $fuelTypesChecked.length === 0;
        let isFromModal = $advanceSearchElectricPowerFields.parents('div').find('#advanceSearchHtml').length === 1;
        if (showElectricFields) {
            // Show electric fields section from Search modal / when user click more filters from ad listing / when user click fuel type checkbox
            if (isFromModal || localFromShowMoreFilters || localIsFuelTypeElementClick) {
                $advanceSearchElectricPowerFields.removeClass('disable-and-hide');
                // Restore focusable elements inside
                $advanceSearchElectricPowerFields.find('[tabindex="-1"]').removeAttr('tabindex');
                $advanceSearchElectricPowerFields.find('[aria-disabled="true"]').removeAttr('aria-disabled');
                $advanceSearchElectricPowerFields.find('[aria-hidden="true"]').removeAttr('aria-hidden');
            } else {
                // Hide electric fields section for ad listing page when all sections are closed
                $advanceSearchElectricPowerFields
                    .addClass('disable-and-hide')
                    .attr('aria-disabled', 'true')
                    .attr('aria-hidden', 'true');

                // Disable all focusable elements inside
                $advanceSearchElectricPowerFields
                    .find('input, button, select, textarea, a, [tabindex]')
                    .attr('tabindex', '-1')
                    .attr('aria-disabled', 'true')
                    .attr('disabled', true);
            }
        } else {
            $advanceSearchElectricPowerFields
                .addClass('disable-and-hide')
                .attr('aria-disabled', 'true')
                .attr('aria-hidden', 'true');

            // Disable all focusable elements inside
            $advanceSearchElectricPowerFields
                .find('input, button, select, textarea, a, [tabindex]')
                .attr('tabindex', '-1')
                .attr('aria-disabled', 'true')
                .attr('disabled', true);
            $('#batteryCapacityFrom, #batteryCapacityTo, #electricRangeFrom, #electricRangeTo').prop(
                'selectedIndex',
                0
            );
            $('#chargingPowerFrom, #chargingPowerTo').val('');
            $('.chargingType input[type=checkbox]').prop('checked', false);
            $(
                '#maximumChargingPowerFrom, #maximumChargingPowerTo, #batteryGuaranteeMonthFrom, #batteryGuaranteeMonthTo, #batteryGuaranteeKmFrom, #batteryGuaranteeKmTo, #electricConsumptionFrom, #electricConsumptionTo, #electricConsumptionPlace'
            ).prop('selectedIndex', 0);
            // Reset header values and remove reset icons for fuel type related fields when hides.
            if (!this.isDesktopView) {
                advanceSearchCommon.showHideResetIcon('chargingTypeFields');
                advanceSearchCommon.showHideResetIcon('chargingFields');
                advanceSearchCommon.showHideResetIcon('batteryGuranteeMonthFields');
                advanceSearchCommon.showHideResetIcon('batteryGuaranteeKmFields');
                advanceSearchCommon.showHideResetIcon('batteryCapacityFields');
                advanceSearchCommon.showHideResetIcon('electricRangeFields');
            }
        }

        if (
            $(`input[id^=fuelType][value="${FUEL_TYPE_ELECTRIC_ID}"]`).prop('checked') &&
            selectedElectricFuelType.length === 1
        ) {
            $('#consumptionFrom, #consumptionTo, #engineSizeFrom, #engineSizeTo').val('');
            $(`input:radio[name="consumptionPlace"][value="${CONSUMPTION_COMBINED_ID}"]`).prop('checked', true);
            // For desktop disable/enable engine size / consumption sections and for mobile remove that sections
            // Reset header values and remove reset icons for consumption/engine size fields when hides.
            advanceSearchCommon.showHideResetIcon('consumptionFields');
            advanceSearchCommon.showHideResetIcon('engineSizeFields');
            $('#fuelConsumptionOpacityDiv, #engineSizeOpacityDiv')
                .closest('.mobileFieldSection')
                .addClass('disable-and-hide')
                .attr('aria-disabled', 'true')
                .attr('aria-hidden', 'true');

            // Disable all focusable elements inside
            $advanceSearchElectricPowerFields
                .find('input, button, select, textarea, a, [tabindex]')
                .attr('tabindex', '-1')
                .attr('aria-disabled', 'true')
                .attr('disabled', true);
        } else {
            // For desktop disable/enable engine size / consumption sections and for mobile remove that sections
            $('#fuelConsumptionOpacityDiv, #engineSizeOpacityDiv')
                .closest('.mobileFieldSection')
                .removeClass('disable-and-hide');
            // Restore focusable elements inside
            $advanceSearchElectricPowerFields.find('[tabindex="-1"]').removeAttr('tabindex');
            $advanceSearchElectricPowerFields.find('[aria-disabled="true"]').removeAttr('aria-disabled');
            $advanceSearchElectricPowerFields.find('[aria-hidden="true"]').removeAttr('aria-hidden');
        }

        if (isResetEvent) {
            // Reset check for technical info section, as consumption/engine size fields are part of that section
            if (this.isDesktopView) {
                advanceSearchCommon.showHideResetIcon('technicalInfoFields');
            } else {
                advanceSearchCommon.showHideResetIcon('consumptionFields');
            }
        }
    },
    checkMakeDependentOptions($vehicleTypeIds, makeId, resetMakeModelSection = '') {
        let params = `changeType=make&vehicleType=${$vehicleTypeIds}&make=${makeId}&changeFrom=advanceSearch`;

        let $model = $('#advance_search #model');
        if (!resetMakeModelSection) {
            $model.prop('disabled', true);
        }

        $.get(Routing.generate('ajax_get_options'), params, function (response) {
            if (!commonUtils.isObjectEmpty(response.model)) {
                advanceSearchCommon.updateSelectElement('model', response.model);
            }
        }).done(function () {
            if (!resetMakeModelSection) {
                setTimeout(function () {
                    $model.prop('disabled', false);
                }, 100);
            }
        });
    },
    showSelectedMakeModelOption(paramModelId = '', paramModelText = '', removeExisting = false) {
        let displayText = '';
        let value = '';
        let $makeSelect = $('#advance_search #make');
        let $model = $('#advance_search #model');
        let makeId = $makeSelect.find('option:selected').val();
        let make = $.trim($makeSelect.find('option:selected').text());
        let modelId = paramModelId;
        let model = paramModelText ? $.trim(paramModelText) : '';

        // Check for make/model already selected then remove it
        $('#makeModelSelected option').each(function () {
            let selectedModelId = $(this).data('model-id');

            // Special BMW series case
            let isModelExist = false;
            if (modelId && modelId.match(/,/) && selectedModelId && isModelExist === false) {
                isModelExist = $.inArray(String(selectedModelId), modelId.split(',')) !== -1;
            } else if (modelId && selectedModelId && String(selectedModelId).match(/,/) && isModelExist === false) {
                isModelExist = $.inArray(modelId, selectedModelId.split(',')) !== -1;
            }

            if (
                $(this).data('make-id') === makeId &&
                (selectedModelId === modelId || '' === selectedModelId || '' === modelId || isModelExist)
            ) {
                $(this).remove();
                $(`#makeModelSelectedDiv [data-id='${this.value}']`).remove();

                // Toggle checkbox for the selected option
                advanceSearchCommon.toggleSelect2Checkbox(selectedModelId, false);
            }
        });

        if (makeId > 0) {
            displayText += `${make} `;
            value += `${makeId},`;
        }

        if (modelId) {
            displayText += `${model} `;
            value += `${('' === makeId ? '0, ' : '') + modelId},`;
        }

        if ('' === displayText || removeExisting) {
            return;
        }

        value = value.replace(/,$/, '');
        $('#makeModelSelected').append(
            `<option data-make-id="${makeId}" data-model-id="${modelId}" value="${value}" selected="selected">${displayText}</option>`
        );
        $('#makeModelSelectedDiv').append(
            `<div data-id="${value}" class="multiple-seleced-text removeMakeModelOpt">${displayText}<span class="form-control__reset-btn">Remove</span></div>`
        );

        // Toggle checkbox for the selected option
        advanceSearchCommon.toggleSelect2Checkbox(modelId, !removeExisting);
        $('#noMakeModelSelected').hide();
        globalThis.dispatchEvent(new Event('advanceMakeModelChange'));

        if (makeId > 0 && '' === modelId) {
            $makeSelect.removeClass('black_text');
        } else if (makeId > 0 && modelId) {
            $model.removeClass('black_text');
            $model.val('');
        }

        advanceSearch.activeInactiveMakeModel('make');
    },
    // Show selected parent dealer list options
    showSelectedParentDealerListOption() {
        let displayText = '';
        let value = '';
        let $parentDealerList = $('#advance_search #parentDealerList');
        let salesforceParentId = $parentDealerList.find('option:selected').val();
        let dealerDisplayName = $parentDealerList.find('option:selected').text();

        if ($('#parentDealerSelected option:selected').length >= advanceSearch.maxDealerShipSelection) {
            $parentDealerList.val(null).trigger('change.select2');
            alert(Translations.advanced_search.dealership_selection_limit);
            return;
        }

        $('#parentDealerSelected option').each(function () {
            if ($(this).data('dealer-parent-id') === salesforceParentId) {
                // parentDealerList already selected
                $(this).remove();
                $(`#parentDealerSelectedDiv [data-id='${this.value}']`).remove();
            }
        });

        if (salesforceParentId && salesforceParentId.trim() !== '') {
            displayText += `${dealerDisplayName} `;
            value += `${salesforceParentId},`;
        }

        value = value.slice(0, -1);
        $('#parentDealerSelected').append(
            `<option data-dealer-parent-id="${salesforceParentId}" value="${value}" selected="selected">${displayText}</option>`
        );
        $('#parentDealerSelectedDiv').append(
            `<div data-id="${value}" class="multiple-seleced-text removeSelectedParentDealerOption">${displayText}<span class="form-control__reset-btn">Remove</span></div>`
        );
        $('#noParentDealerSelected').hide();
        globalThis.dispatchEvent(new Event('advanceParentDealerChange'));

        if (salesforceParentId && salesforceParentId.trim() !== '') {
            $parentDealerList.val(null).trigger('change.select2').removeClass('black_text');
        }
    },
    removeMakeModelOption(clickedElement) {
        clickedElement.remove();
        $(`#advance_search #makeModelSelected option[value="${clickedElement.data('id')}"]`).remove();
        globalThis.dispatchEvent(new Event('advanceMakeModelChange'));
        if (0 === $('#advance_search .removeMakeModelOpt').length) {
            $('#advance_search #make').prop('selectedIndex', 0);
            advanceSearch.advanceSearchMakeSelect2Event();
            $('#advance_search #model').find('option').not(':first').remove();
            $('#advance_search #noMakeModelSelected').show();
            advanceSearchCommon.showHideResetIcon('makeFields');
        }
    },
    // Change selected make/model text
    activeInactiveMakeModel(id) {
        let $elementId = $(`#advance_search #${id}`);
        let $disabledModelSection = $elementId.closest('.desktopSectionTopDiv').find('#disabledModelSection div');
        let isMakeSelection = id === 'make';
        if (
            (isMakeSelection &&
                '' === $('#advance_search #make option:selected').val() &&
                '' === $('#advance_search #model option:selected').val()) ||
            (!isMakeSelection && '' === $elementId.find('option:selected').val())
        ) {
            $elementId.removeClass('black_text');
            $disabledModelSection.addClass('disable-block__only-this');
        } else {
            $elementId.addClass('black_text');
            $disabledModelSection.removeClass('disable-block__only-this');
        }
    },
    async resetFormElement(object, executeSearchCounterCall) {
        const shouldExecuteSearchCounterCall = executeSearchCounterCall !== false;
        let fieldSelectorClass = this.isDesktopView ? '.desktopSectionTopDiv' : '.mobileFieldSection';
        let fieldSectionSelectorClass = this.isDesktopView
            ? '.desktopFieldSection'
            : '.advance-search-tool__row_col_section';
        let $section = $(`#advance_search #${object.closest(fieldSelectorClass).attr('id')}`);
        $section.removeClass('searchSectionChanged');
        $section.find('.resetAdvField').hide();
        let $sectionFields = $section.find(fieldSectionSelectorClass);
        $sectionFields.find('select').each(function () {
            if ('' !== $(this).val() && $(this).val() !== null) {
                if ($(this).val().length > 1) {
                    $(this)[0].selected = true;
                }
            }

            this.value = '';
            advanceSearch.resetElementsById($(this).attr('id'));
        });

        if (!this.isDesktopView) {
            $('.preferenceAccessoryCheckbox').each(function () {
                if (
                    $sectionFields.find(`#advance_search_accessories_${$(this).data('preference-accessory-id')}`).length
                ) {
                    $(`#preferences_accessory_${$(this).data('preference-accessory-id')}`).prop('checked', false);
                }
            });

            if ($section.find('#colorInfoDisable').length) {
                $('.preferenceColorCheckbox').prop('checked', false);
            }
        }

        if ($section.find('#colorInfoFields').length) {
            $('.preferenceColorCheckbox').prop('checked', false);
        }

        $sectionFields.find('input:checkbox').prop('checked', false);
        $sectionFields.find('input:checkbox[name=finlandOnly]').prop('checked', false);
        $sectionFields.find('.postedBy').prop('checked', true);
        $sectionFields.find('input:radio').prop('checked', false);
        $sectionFields
            .find(
                `input:radio[name=statusType][value="${AD_TYPE_FORSALE_EN}"], input:radio[name=accessoriesCondition][value="and"]`
            )
            .prop('checked', true);
        $sectionFields
            .find(
                `input:radio[name=gearType][value=""], input:radio[name="consumptionPlace"][value="${CONSUMPTION_COMBINED_ID}"], input:radio[name="electricConsumptionPlace"][value="${CONSUMPTION_COMBINED_ID}"], input:radio[name="roadWorthy"][value=""], input:radio[name="steeringWheelType"][value=""]`
            )
            .prop('checked', true);
        $sectionFields.find('input:text').val('');
        $sectionFields.find(':input[type="number"]').val('');
        $sectionFields.find('input[type=checkbox], select').prop('disabled', false);
        $sectionFields
            .find('input:checkbox[name=isPriced],input:checkbox[name=vatDeduct],input:checkbox[name=taxFree]')
            .prop('checked', false);
        $sectionFields.find('input:checkbox[name=excludeMakeModel]').prop('checked', false);
        $sectionFields.find('select[name="powerUnit"]').val(POWER_UNIT_KW);

        // Reset slider
        if ($section.find('#yearSlider').length) {
            searchYearSlider.setSlider(0, 0);
        }

        if ($section.find('#priceSlider').length) {
            searchPriceSlider.setSlider(0, 0);
        }

        if ($section.find('#kilometerSlider').length) {
            searchMileageSlider.setSlider(0, 0);
            $('#advance_search .disableForUndriven').removeClass('disabled-element');
        }

        // Reset fuel type field as per desktop/mobile view
        if ('fuelTypeFields' === $section.attr('id') || 'basicInfoSelection' === $section.attr('id')) {
            advanceSearch.showHideDependantElectricField(false, true, true);
        }

        // Reset drive type field as per desktop/mobile view
        if ('driveTypeFields' === $section.attr('id') || 'technicalInfoSelection' === $section.attr('id')) {
            let $staticDriveTypeOption = $('#advance_search #driveTypeFourWheel');
            $staticDriveTypeOption.prop('checked', false);
        }

        // Reset accessories field as per desktop/mobile view
        if ('accessoriesFields4' === $section.attr('id') || 'accessoriesInfoSelection' === $section.attr('id')) {
            let $staticAccessoriesOption = $(
                '#advance_search #accessoryPlugInCharge, #advance_search #accessoryTowBar, .preferenceAccessoryCheckbox'
            );
            $staticAccessoriesOption.prop('checked', false);
            $staticAccessoriesOption.closest('div').removeClass('opacity_class pointer-events-none');
            $('#accessoriesInfoSelection').removeClass('disable-and-hide z1');
        }

        $sectionFields.find('.anyCheckBox input[type=checkbox]').prop('checked', true);

        if ('makeModelSelection' === $section.attr('id')) {
            // Here data 'resetMakeModelSection' passed with trigger to differentiate click and trigger event
            // when disable the model dropdown and hide reset make/model section icon
            $('#advance_search #make').trigger('change', ['resetMakeModelSection']);
        }

        if ('dealerShipFields' === $section.attr('id')) {
            advanceSearch.resetElementsById('parentDealerList');
        }

        let $finlandOnly = $('#advance_search #finlandOnly');
        if ($sectionFields.find('.advSearchRegionTownOptions').length > 0 && !$finlandOnly.prop('checked')) {
            $('#regionTownSelected').empty();
            $('.removeRegionTownOpt').remove();
        }

        if ('basicInfoSelection' === $section.attr('id') || 'locationFields' === $section.attr('id')) {
            advanceSearchCommon.changeLocationDropdown(false);
        }

        // Show/hide reset icon as per desktop/mobile view
        advanceSearchCommon.showHideResetIcon(
            this.isDesktopView ? $sectionFields.attr('id') : object.closest(fieldSelectorClass).attr('id')
        );

        // Show status value in field header for mobile view only
        if ('statusTypeFields' === $section.attr('id')) {
            advanceSearchFieldHeader.showSelectedValueInFieldHeader($('[name="statusType"]'));
        }

        // Show posted by value in field header for mobile view only
        if ('postedByFields' === $section.attr('id')) {
            advanceSearchFieldHeader.showSelectedValueInFieldHeader($('[name="postedBy[]"]'));
        }

        if (shouldExecuteSearchCounterCall) {
            // Prepare fields for remove from storage
            let fieldNames = [];
            $sectionFields.find('input, select').each(function () {
                let fieldName = $(this).attr('name').replace('[]', '');
                // Replace key names for fields which have different key name in storage
                fieldName = fieldName === 'makeModel' ? 'makeModels' : fieldName;
                fieldName = fieldName === 'carType' || fieldName === 'vanType' ? 'bodyType' : fieldName;
                // Add the name to the array if it's not already there (to ensure uniqueness)
                if ($.inArray(fieldName, fieldNames) === -1) {
                    fieldNames.push(fieldName);
                }
            });

            await searchFormStorage.resetFields(fieldNames);

            globalThis.dispatchEvent(
                new CustomEvent('advanceFieldChange', {
                    detail: {
                        action: 'resetPartially',
                        fieldName: '',
                        fieldValue: '',
                    },
                })
            );
        }
    },
    resetElementsById(elementId) {
        if ('makeModelSelected' === elementId && $('#advance_search #makeModelSelected option').length > 0) {
            $('#advance_search #makeModelSelected').empty();
            $('#advance_search #noMakeModelSelected').show();
            $('#advance_search .removeMakeModelOpt').remove();
            $('#addAnotherMakeModel').hide();
        }
        if (
            ('regionTownSelected' === elementId || 'locationFields' === elementId) &&
            $('#advance_search #regionTownSelectedDiv').length
        ) {
            let $regionTownSelected = $('#advance_search #regionTownSelected');
            $regionTownSelected.empty();
            $('#advance_search .removeRegionTownOpt').remove();
            $('#advance_search #addAnotherLocation, #advance_search #selectedLocationOptionValueCaption').hide();
        }
        if ('parentDealerList' === elementId && $('#advance_search #parentDealerSelected option').length > 0) {
            $('#advance_search #parentDealerSelected').empty();
            $('#advance_search #noParentDealerSelected').show();
            $('#advance_search .removeSelectedParentDealerOption').remove();
            $('#advance_search #parentDealerSelected').prop('selectedIndex', 0);
            advanceSearch.advanceSearchParentDealerSelect2Event();
        }
    },
    resetAnyElement(object) {
        let $section = $(`#advance_search #${object.closest('.desktopSectionTopDiv').attr('id')}`);
        $section.removeClass('searchSectionChanged');
        $section.find('.resetAdvField').hide();
        let $sectionFields = $section.find('.desktopFieldSection');
        $sectionFields.find(`.anyCheckBox input[name="${object.attr('name')}"]`).prop('checked', true);
    },
    checkVehicleTypeDependentOptions() {
        let vehicleTypeIds = $('input[id^=vehicleType]:checked')
            .map(function () {
                return Number.parseInt(this.value, 10);
            })
            .get()
            .join();

        let updateFields = ['make'];
        let displayMostPopular = vehicleTypeIds.length === 0;
        let params = `changeType=vehicleType&changeFrom=advanceSearch&isDisplayMostPopular=${displayMostPopular}&vehicleType=${vehicleTypeIds}`;
        $.get(Routing.generate('ajax_get_options'), params, function (response) {
            $.each(response, function (key, value) {
                if (updateFields.includes(key)) {
                    if (!commonUtils.isObjectEmpty(value)) {
                        advanceSearchCommon.updateSelectElement(key, value);
                    } else {
                        let $dependentElement = $(`#advance_search #${key}`);
                        $dependentElement.find('option').not(':first').remove();
                    }
                }
            });
        });
    },
    selectDeselectAccessories($accessory) {
        let accessoryIds = $accessory.val().split('_');
        let accessoryParentId = $accessory.data('parent-id');

        if (accessoryIds.length > 1) {
            $.each(accessoryIds, function (_index, value) {
                $(`#advance_search_accessories_${value}`).prop('checked', $accessory.is(':checked'));
                $(`#preferences_accessory_${value}`).prop('checked', $accessory.is(':checked'));
            });
        } else if (typeof accessoryParentId !== 'undefined') {
            let childAccessoryIds = accessoryParentId.split('_');
            let selectedAccessories = 0;
            let unselectedAccessories = 0;

            $.each(childAccessoryIds, function (_index, value) {
                if ($(`#advance_search_accessories_${value}`).is(':checked')) {
                    selectedAccessories++;
                } else {
                    unselectedAccessories++;
                }
            });

            if (
                selectedAccessories === childAccessoryIds.length ||
                unselectedAccessories === childAccessoryIds.length ||
                $accessory.is(':checked')
            ) {
                $(`#advance_search_accessories_${accessoryParentId}`).prop('checked', $accessory.is(':checked'));
            }
        }
    },
    validateCo2Emission(caller) {
        let $co2EmissionFrom = $('#advance_search #co2EmissionFrom');
        let $co2EmissionTo = $('#advance_search #co2EmissionTo');
        let $caller = $(`#advance_search #${caller}`);
        if (
            $co2EmissionFrom.val() &&
            $co2EmissionTo.val() &&
            Number.parseInt($co2EmissionFrom.val(), 10) > Number.parseInt($co2EmissionTo.val(), 10)
        ) {
            alert(Translations.advanced_search.error_message.invalid_co2_range);
            $caller.val('').focus();
        }
    },
    validateTowWeight(caller) {
        let $towWeightFrom = $('#advance_search #towWeightFrom');
        let $towWeightTo = $('#advance_search #towWeightTo');
        let $caller = $(`#advance_search #${caller}`);
        if (
            $towWeightFrom.val() &&
            $towWeightTo.val() &&
            Number.parseInt($towWeightFrom.val(), 10) > Number.parseInt($towWeightTo.val(), 10)
        ) {
            alert(Translations.advanced_search.error_message.invalid_tow_weight_range);
            $caller.val('').focus();
        } else if ($caller.val() && ($caller.val() < this.minimumTowWeight || $caller.val() > this.maximumTowWeight)) {
            $caller.val('').focus();
            alert(Translations.advanced_search.error_message.invalid_tow_weight);
        }
    },
    validateChargingPower(caller) {
        let $chargingPowerFrom = $('#advance_search #chargingPowerFrom');
        let $chargingPowerTo = $('#advance_search #chargingPowerTo');
        let $caller = $(`#advance_search #${caller}`);
        if (
            $chargingPowerFrom.val() &&
            $chargingPowerTo.val() &&
            Number.parseInt($chargingPowerFrom.val(), 10) > Number.parseInt($chargingPowerTo.val(), 10)
        ) {
            alert(Translations.advanced_search.error_message.invalid_chargin_power_range);
            $caller.val('').focus();
        } else if (
            $caller.val() &&
            ($caller.val() < this.minimumChargingPower || $caller.val() > this.maximumChargingPower)
        ) {
            alert(Translations.advanced_search.error_message.invalid_chargin_power);
            $caller.val('').focus();
        }
    },
    validateYear(element) {
        let allowMinimumValue = searchYearSlider.list[0];
        let allowMaximumValue = searchYearSlider.list[searchYearSlider.list.length - 1];
        let elementName = element.attr('name');
        let value = Number.parseInt(element.val(), 10);
        if (value < allowMinimumValue || value > allowMaximumValue) {
            alert(
                Translations.advanced_search.invalid_range_value
                    .replace('%min%', allowMinimumValue)
                    .replace('%max%', allowMaximumValue)
            );
            element.val('').focus();
        } else if (elementName === 'yearFrom' && value > Number.parseInt($('#advance_search #yearTo').val(), 10)) {
            alert(Translations.advanced_search.invalid_minimum_value);
            element.val('').focus();
        } else if (elementName === 'yearTo' && value < Number.parseInt($('#advance_search #yearFrom').val(), 10)) {
            alert(Translations.advanced_search.invalid_maximum_value);
            element.val('').focus();
        }

        // Reset slider when change value manually entering in text box
        if (elementName === 'yearFrom') {
            searchYearSlider.setSlider(element.val(), $('#advance_search #yearTo').val());
        } else {
            searchYearSlider.setSlider($('#advance_search #yearFrom').val(), element.val());
        }
    },
    validateInspectionAndRegistration() {
        if ($('#advance_search #lastInspectionMonth').val() && $('#advance_search #lastInspectionYear').val() === '') {
            alert(Translations.advanced_search.error_message.invalid_inspection_year);
            $('#advance_search #lastInspectionYear').focus();
            return false;
        }
        if (
            $('#advance_search #firstRegistrationMonth').val() &&
            $('#advance_search #firstRegistrationYear').val() === ''
        ) {
            alert(Translations.advanced_search.error_message.invalid_registration_year);
            $('#advance_search #firstRegistrationYear').focus();
            return false;
        }

        return true;
    },
    advanceSearchMakeSelect2Event() {
        $('#advance_search #make').select2({
            placeholder: Translations.select,
            dropdownCssClass: 'advance-search-tool__select2-dropdown',
            matcher: commonUtils.select2CustomMatchForGroup,
            language: {
                noResults() {
                    return Translations.no_result_text;
                },
            },
        });
    },
    advanceSearchModelSelect2Event() {
        $('#advance_search #model').select2({
            closeOnSelect: false,
            placeholder: Translations.select,
            dropdownCssClass: 'advance-search-tool__select2-dropdown advance-search-tool__select2-checkbox',
            matcher: commonUtils.select2CustomMatch,
            templateResult(data) {
                if (!data.id) {
                    return data.text; // Placeholder
                }

                // Check if this model is already selected in makeModelSelected
                const modelId = data.id;
                let isSelected = false;

                $('#makeModelSelected option').each(function () {
                    if ($(this).data('model-id') === modelId) {
                        isSelected = true;
                        return false; // Break loop
                    }
                    return undefined;
                });

                const $result = $('<span class="select2-checkbox-option"></span>');
                const $checkbox = $('<input type="checkbox" class="select2-checkbox">').prop('checked', isSelected);
                const $label = $('<span class="select2-checkbox-label"></span>').text(data.text);
                $result.append($checkbox).append($label);
                return $result;
            },
            language: {
                noResults() {
                    return Translations.no_result_text;
                },
            },
        });
    },
    advanceSearchParentDealerSelect2Event() {
        $('#advance_search #parentDealerList').select2({
            placeholder: Translations.advanced_search.dealer_ship_list_placeholder,
            dropdownCssClass: 'advance-search-tool__select2-dropdown',
            matcher: commonUtils.select2CustomMatchForGroup,
            language: {
                noResults() {
                    return Translations.no_result_text;
                },
            },
        });
    },
    saveSearchAgent(source) {
        if (!commonUtils.isUserLogin()) {
            almaTunnusLogin.init(source);
            return false;
        }

        if (advanceSearch.validateInspectionAndRegistration()) {
            advanceSearch.saveSearchAgentData(true);
        }

        return false;
    },
    async saveSearchAgentData(isSavedAgent = false, isSearchFromListing = false) {
        const formData = await searchFormStorage.getFormData();
        if (isSavedAgent) {
            // Set hash, Hash set only when click on "edit search agent" link
            formData.searchHash = $('#advance_search #searchHash').val();
        }

        // This will be used for Google Tag Manager
        localStorage.setItem('searchFrom', isSearchFromListing ? 'list' : 'advanced');

        // set sorting option
        let $selectNavigation = $('.selectNavigation');
        if ($selectNavigation.length) {
            let [sortBy, sortOrder] = $selectNavigation.val()?.split('_') || [];
            formData.sortBy = sortBy;
            formData.sortOrder = sortOrder;
        }

        // Add CSRF token
        const csrfToken = $('.save-search-csrf-token').first().val() || '';
        if (!csrfToken) {
            console.error('Missing CSRF token for save_search');
            return;
        }

        $.ajax({
            url: Routing.generate('save_search'),
            type: 'POST',
            data: { ...formData, _csrf_token: csrfToken },
            success(response) {
                if (response.status === 'success' && response.searchHash) {
                    // Remove the storage key from IndexedDB
                    searchFormStorage.removeKey(searchFormStorage.storageKey);
                    globalThis.$.colorbox.close();
                    let routeName = isSavedAgent ? 'save_search_agent' : 'advance_search_list';
                    globalThis.location.href = Routing.generate(routeName, { haku: response.searchHash });
                } else {
                    console.error('Technical error occurred while search.');
                }
            },
            error(jqXHR, textStatus, errorThrown) {
                console.error('Save search failed:', { status: jqXHR.status, textStatus, errorThrown });
                // Reload only for CSRF token errors (403 Forbidden or 400 Bad Request with CSRF message)
                if (jqXHR.status === 403 || (jqXHR.status === 400 && jqXHR.responseJSON?.error_code === 'csrf_token_invalid')) {
                    console.warn('CSRF token invalid, reloading page to refresh token');
                    globalThis.location.reload(true);
                }
            },
        });
    },
    showHideAddMakeModelSelectionLink() {
        if (this.isDesktopView) {
            return;
        }

        if ($('#makeModelSelected option').length === 0) {
            $('#addAnotherMakeModel').hide();
        } else {
            $('#addAnotherMakeModel').show();
        }
    },
    checkOptionsWithAnyCheckbox(anyCheckboxId, field) {
        let hideResetIcon = true;
        let anyCheckBox = `#advance_search #${anyCheckboxId}`;
        let inputField = `input[name="${field}"]`;
        if ($(anyCheckBox).is(':checked')) {
            $(inputField).prop('checked', false);
        } else if ($(`${inputField}:checked`).length === 0) {
            $(anyCheckBox).prop('checked', true);
        }

        // Reset static drive type option
        if (field === 'driveType[]') {
            advanceSearch.advanceSearchMainToStaticOption(
                $(`input[name="${this.drive_type_field_name}"][value="${DRIVE_TYPE_FOUR_WHEEL_ID}"]`)
            );
        }

        // Due to combination of vehicleType/fuelType/carType, need to check all are checked or not based on that show/hide reset icon
        const filters = ['vehicleType[]', 'fuelType[]', 'carType[]'];
        hideResetIcon =
            filters.every((name) => $(`#advance_search input[name="${name}"]:checked`).length === 0) ||
            field === 'driveType[]';

        // Reset header value for field
        advanceSearchFieldHeader.showSelectedValueInFieldHeader($(`[name="${field}"]`), true);

        // Remove field reset icon
        let $section = $(`#advance_search #${$(`#${anyCheckboxId}`).closest('.desktopSectionTopDiv').attr('id')}`);
        $section.removeClass('searchSectionChanged');
        if (hideResetIcon) {
            $section.find('.resetAdvField').hide();
            advanceSearchCommon.enableDisableResetLink();
        } else {
            $section.find('.resetAdvField').show();
        }
    },
    setUnsetAnyCheckbox(anyCheckboxId, field) {
        let anyCheckBox = `#advance_search #${anyCheckboxId}`;
        let inputField = `#advance_search input[name="${field}"]`;
        $(anyCheckBox).prop('checked', $(`${inputField}:checked`).length === 0);
    },
    showAllSectionOpenByDefault() {
        if (this.isDesktopView) {
            $('#advSearchContainer .desktopSectionTopDiv').addClass('post-ad__section_open');
        }
    },
    disableOrHideAccessoriesSection(resetSelection = false) {
        let $accessoriesInfoSelection = $('#accessoriesInfoSelection');
        if (resetSelection) {
            $('#advance_search #accessoryPlugInCharge, #advance_search #accessoryTowBar').prop('checked', false);
            $accessoriesInfoSelection.find('input:checkbox').prop('checked', false);
        }

        if ($('input[name="statusType"]:checked').val() === AD_STATUS_SOLD) {
            $('#advance_search #accessoryPlugInCharge, #advance_search #accessoryTowBar, .preferenceAccessoryCheckbox')
                .closest('div')
                .addClass('opacity_class pointer-events-none');
            $('.preferenceAccessoryCheckbox').prop('checked', false);
            $accessoriesInfoSelection.addClass('disable-and-hide z1');
        } else {
            $('#advance_search #accessoryPlugInCharge, #advance_search #accessoryTowBar, .preferenceAccessoryCheckbox')
                .closest('div')
                .removeClass('opacity_class pointer-events-none');
            $accessoriesInfoSelection.removeClass('disable-and-hide z1');
        }

        // show/hide reset icons
        if (this.isDesktopView) {
            advanceSearchCommon.showHideResetIcon('accessoriesInfoFields');
        } else {
            // Reset accessories sections field header for mobile view
            advanceSearchFieldHeader.showSelectedValueInFieldHeader($('[name="accessories[]"]'));

            // Hide reset icon for each accessories field section
            advanceSearchCommon.showHideResetIcon('accessoriesFields1');
            advanceSearchCommon.showHideResetIcon('accessoriesFields2');
            advanceSearchCommon.showHideResetIcon('accessoriesFields3');
            advanceSearchCommon.showHideResetIcon('accessoriesFields4');
        }
    },
    setDesktopMobileView(isResized = false) {
        let isSearchModalDesktopView = commonUtils.isSearchModalDesktopView();
        advanceSearch.isDesktopView = isSearchModalDesktopView;
        advanceSearchCommon.isDesktopView = isSearchModalDesktopView;
        advanceSearchFieldHeader.isDesktopView = isSearchModalDesktopView;

        if (isResized) {
            advanceSearchCommon.showResetIconOnLoad(isResized);
            advanceSearchFieldHeader.showSelectedValueInFieldOnLoad();
        }
    },
    removeSelectedParentOption(clickedElement) {
        clickedElement.remove();
        $(`#parentDealerSelected option[value="${clickedElement.data('id')}"]`).remove();
        const parentDealerOpts = $('#parentDealerSelectedDiv .removeSelectedParentDealerOption');
        const selectedParentDealerCount = parentDealerOpts.length;

        if (0 === selectedParentDealerCount) {
            $('#advance_search #parentDealerSelected').empty();
            advanceSearch.advanceSearchParentDealerSelect2Event();
            $('#noParentDealerSelected').show();
            advanceSearchCommon.showHideResetIcon(this.isDesktopView ? 'otherInfoFields' : 'dealerShipFields');
        }
        globalThis.dispatchEvent(new Event('advanceParentDealerChange'));
    },
    async adCounter() {
        const formData = await searchFormStorage.getFormData();
        $.post(Routing.generate('advance_search_counter'), {
            ...formData,
            formName: advanceSearchCommon.formName,
        }).done(function (result) {
            let searchCounterText = ` (${result.total_ads}) `;
            $('#advSearchContainer').find('.advanceSearchCounter').text(searchCounterText);

            // Change counter only for left side listing page, Do not change for home page
            if ($('.leftSearchForm').length) {
                $('form[name=simple_search]')
                    .find('.searchCounter')
                    .html(`${Translations.show_result} <span>(${result.total_ads})</span>`);
            }
        });
    },
};

globalThis.advanceSearch = advanceSearch;
